import ImageSkeleton from "../skeletons/ImageSkeleton"
import ScheduleDetail from "./ScheduleDetail"
import ScheduleBorder from "@/assets/imgs/cultural-event/schedule-border.webp"
import Calendar from "@/assets/icons/calendar.webp"
import Clock from "@/assets/icons/clock.webp"
import Location from "@/assets/icons/location-line-colored.webp"
import EventCardSkeleton from "../skeletons/EventCardSkeleton"
import { Link } from "react-router-dom"

const EventCard = ({ event, hasLocation = false, hasSchedule = false, pathname }) => {
  const mediaLg = window.matchMedia("(min-width: 1024px)")

  // TODO: pindahkan jadii helper
  const getTextSnippet = (html) => {
    const text = html.replace(/<[^>]*>/g, "")
    const clean = text.replace(/&[^;]+;/g, "")

    if (clean.length > 100) {
      return `${clean.slice(0, mediaLg.matches ? 500 : 250)}...`
    } else {
      return clean
    }
  }

  return (
    <>
      <div className="flex max-lg:flex-col max-lg:gap-y-4 lg:gap-x-8 lg:mb-10">
        <div className="w-4/5 lg:w-2/5 bg-cover bg-center bg-no-repeat">
          <Link to={`${pathname}/${event?.slug}`}>
            {/* TODO: pada tour guide, gambar kagak muncul */}
            <ImageSkeleton src={event.photo} custCls="rounded-[40px] w-full h-[230px] sm:h-[300px] lg:h-[330px] object-cover" custH="h-[230px] sm:h-[300px] lg:h-[330px]" custStyle="rounded-[40px]" />
          </Link>
        </div>
        <div className="w-full lg:w-3/5 bg-[rgba(255,255,255,0.7)] rounded-3xl py-4 sm:py-5 px-2 sm:px-4 font-agcasmlt flex h-[230px] sm:h-[300px] lg:h-[330px]">
          <div className="relative w-full">
            {hasSchedule &&
              <div className="flex px-4 relative mb-5 sm:mb-9 xl:mb-10">
                <img width="100" src={ScheduleBorder} className="w-[300px] sm:w-[400px] md:w-[450px]" />
                <div className="absolute flex items-center gap-1.5 sm:gap-x-3 left-7">
                  <ScheduleDetail imgPath={Calendar} isDate
                    isRange={!!event?.date_ranges?.length}
                    detail1={event?.date_multiples?.length > 0 ?
                      event?.date_multiples :
                      event?.date_ranges[0].start_date}
                    detail2={event?.date_multiples?.length > 0 ?
                      event?.date_multiples[event?.date_multiples.length - 1] :
                      event?.date_ranges[0].end_date}
                    conj={event?.date_ranges?.length == 1 ?
                      " - " :
                      event?.date_multiples?.length == 1 ?
                        "" :
                        " & "
                    } />
                  <div className="border border-separate border-[#9b894d] h-6 sm:h-8 md:h-9"></div>
                  <ScheduleDetail imgPath={Clock}
                    detail1={event.time_ranges[0].start_time}
                    detail2={event.time_ranges[0].end_time}
                    conj=" - " />
                </div>
              </div>
            }
            <div>
              <div className="px-[18px] text-[#6e6060] mb-3 sm:mb-4 xl:mb-5">
                <Link to={`${pathname}/${event.slug}`}>
                  <h2 className="font-light text-2xl sm:text-4xl xl:text-5xl mb-2 sm:mb-3 xl:mb-4">{event.name}</h2>
                </Link>
                <p className="text-justify font-light text-[14px] sm:text-[18px] xl:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px]">
                  {/* {event.description.length > 100
                    ? `${event.description.slice(0, mediaLg.matches ? 500 : 250)}...`
                    : event.description} */}
                  {getTextSnippet(event.description)}
                </p>
              </div>
              {hasLocation &&
                <div className="flex items-center px-[18px] absolute bottom-0">
                  <img width="100" src={Location} className="w-4 sm:w-5 mr-1.5 sm:mr-3" />
                  <span className="font-light text-[22px] sm:text-[26px] xl:text-[28px] text-[#6e6060] relative -bottom-1.5">{event.location}</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div className="border-b-[1.5px] border-[#6d625a] w-3/5 mx-auto my-6 sm:my-8 lg:hidden"></div>
    </>
  )
}

const EventCards = ({ events, onReq = false, hasLocation = false, hasSchedule = false, pathname }) => {
  return (
    <>
      {events?.map((e, i) => (
        <div key={i}>
          <EventCard event={e} hasLocation={hasLocation} hasSchedule={hasSchedule} pathname={pathname} />
        </div>
      ))}
      {onReq && <EventCardSkeleton />}
    </>
  )
}

export {
  EventCard,
  EventCards
}